import React from "react";

export const LazyCreateRoundPage = React.lazy(
  () => import("modules/projectRole/pages/RoundsPage/pages/CreateRoundPage"),
);
